import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { DocumentUpload } from './DocumentUpload';
import { DocumentList } from './DocumentList';
import { useDocuments } from '@/hooks/useDocuments';
import { Separator } from '@/components/ui/separator';

interface PODUploadDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  orderId: string;
  orderNumber: string;
}

export const PODUploadDialog = ({ 
  open, 
  onOpenChange, 
  orderId,
  orderNumber 
}: PODUploadDialogProps) => {
  const { 
    documents, 
    uploadDocument, 
    isUploading,
    deleteDocument,
    isDeleting 
  } = useDocuments(orderId);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold text-[#37699E] font-['Lexend_Deca']">
            Documents de livraison
          </DialogTitle>
          <DialogDescription className="text-[#5A6B7A] font-['Funnel_Sans']">
            Commande {orderNumber}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {/* Upload Section */}
          <div className="space-y-3">
            <h3 className="text-lg font-medium text-[#2D3748] font-['Lexend_Deca']">
              Ajouter un document
            </h3>
            <DocumentUpload
              orderId={orderId}
              onUpload={uploadDocument}
              isUploading={isUploading}
            />
          </div>

          <Separator className="bg-[#DBE2EA]" />

          {/* Documents List */}
          <div className="space-y-3">
            <h3 className="text-lg font-medium text-[#2D3748] font-['Lexend_Deca']">
              Documents uploadés ({documents.length})
            </h3>
            <DocumentList
              documents={documents}
              onDelete={deleteDocument}
              isDeleting={isDeleting}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
